<template>
  <div v-if="featuredBanners.length">
    <div class="mx-auto">
      <swiper
        :modules="swiperOptions.swiperModules"
        :slides-per-view="swiperOptions.slidesPerView"
        :space-between="swiperOptions.spaceBetween"
        :breakpoints="swiperOptions.breakpoints"
        :autoplay="swiperOptions.autoplay"
        :pagination="swiperOptions.pagination"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
        class=""
      >
        <swiper-slide v-for="item in featuredBanners" :key="item.id">
           <a :href="item.link || '#'" @click.prevent="promoClick(item)">
            <div class="relative content-feature-img cursor-pointer pb-32" v-bind:style="{ backgroundImage: getBannerImage(item) }">
              <div class="absolute inset-x-0 bottom-0 text-white pl-3 pb-2">
                &nbsp;
              </div>
            </div>
          </a>
        </swiper-slide>
      </swiper>
      <!-- <div class="swiper-pagination"></div> -->
    </div>
  </div>
</template>
<script>
import { onMounted } from 'vue'
import { useBanners } from '@/composables/useBanners'
import { Swiper, SwiperSlide } from 'swiper/vue'
import SwiperCore, { Autoplay, Pagination } from 'swiper'
import 'swiper/swiper-bundle.min.css'

SwiperCore.use([Autoplay, Pagination])

export default {
  name: 'HomeFeatured',
  components: {
    Swiper,
    SwiperSlide
  },
  setup () {
    const { featuredBanners, searchBanners, getBannerImage } = useBanners()

    onMounted(() => {
      searchBanners()
    })

    const promoClick = (item) => {
      if (!item) {
        return
      }

      if (item.link) {
        window.location.href = item.link
      }
    }

    const swiperOptions = {
      slidesPerView: 1,
      spaceBetween: 12,
      breakpoints: {
      },
      autoplay: {
        delay: 8000,
        disableOnInteraction: false
      },
      pagination: {
        clickable: true,
        dynamicButtons: true,
        el: '.swiper-pagination'
      },
      swiperModules: [Autoplay, Pagination]
    }

    const onSwiper = (swiper) => {
      // console.log(swiper)
    }
    const onSlideChange = () => {
      // console.log('slide change')
    }

    const joinTheMovement = () => {
      const scrollTo = document.getElementById('mailing-list')
      scrollTo.scrollIntoView({ behavior: 'smooth' })
    }

    return {
      featuredBanners,
      getBannerImage,
      onSwiper,
      onSlideChange,
      swiperOptions,
      promoClick,
      joinTheMovement
    }
  }
}
</script>
